<template>
    <div>

        <vue-headful title="Safety Settings :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light"><i class="fa fa-cogs"></i> Admin</li>
                <li class="breadcrumb-item active">Safety Settings</li>
                <li class="ml-3">
                    <router-link :to="`/admin/safety-settings-edit`" class="btn btn-sm btn-success"><i class="fa fa-plus"></i></router-link>
                </li>
            </ol>
        </h4>

        <div class="card">
            <div class="card-body">
                <safety-settings-list />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {

            }
        },

        methods: {

        },
    }
</script>
